var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80772 2C8.15082 2 6.8077 3.34315 6.8077 5V11C6.8077 12.6569 8.15082 14 9.80772 14C11.4645 14 12.8077 12.6569 12.8077 11V5C12.8077 3.34315 11.4645 2 9.80772 2ZM9.80772 0C12.5691 0 14.8077 2.23858 14.8077 5V11C14.8077 13.7614 12.5691 16 9.80772 16C7.04627 16 4.8077 13.7614 4.8077 11V5C4.8077 2.23858 7.04627 0 9.80772 0ZM0 12.9615L1.96154 12.5692C2.69083 16.2361 5.9265 19 9.80772 19C13.6889 19 16.9245 16.2361 17.6538 12.5692L19.6154 12.9615C18.7037 17.5452 14.6592 21 9.80772 21C4.9562 21 0.91162 17.5452 0 12.9615Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.708c1267430114b7d9fac463dcb96afa.svg";
export { ForwardRef as ReactComponent };